import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnInit,
} from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormBuilder,
    FormGroup,
    FormGroupDirective,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ReactiveFormsService } from '../../providers/reactive-forms.service';


@Component({
    selector: 'roblex-input-date-ramge-picker',
    templateUrl: './input-date-ramge-picker.component.html',
    styleUrls: ['./input-date-ramge-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => InputDateRamgePickerComponent),
        },
    ],
})
export class InputDateRamgePickerComponent implements OnInit, ControlValueAccessor {
    /**
     * Control  of input form field component
     */
    control: AbstractControl;
    /**
     * Value  of input field component
     */
    _value = '';
    /**
     * Input identifier of input form field component
     */
    @Input() identifier: string;
    /**
     * Input class name of input form field component
     */
    @Input() className: string;
    /**
     * Input  of input form field component
     */
    @Input() formControlName: string;
    /**
     * Input  of input field component
     */
    @Input() label = 'date picker label';
    /**
     * Input  of input field component
     */
    @Input() disabled = false;
    /**
     * Input  of input field component
     */
    @Input() placeholder = '';
    /**
     * Input  of input datepicker component
     */
    @Input() change: EventEmitter<any> = new EventEmitter();
    /**
     * Gets value
     */
    get value() {
        return this._value;
    }
    /**
     * Sets value
     */
    set value(val) {
        this._value = val;
        this.onChangeCallback(this._value);
    }
    /**
     * Gets form
     */
    get form() {
        return this.controlContainer.formDirective
            ? (this.controlContainer.formDirective as FormGroupDirective).form
            : null;
    }
    /**
     * Gets class form fiel
     */
    get classFormFiel() {
        const classList = {};

        classList['date-range-picker'] = true;
        classList['mat-form-field-invalid'] =
            this.control?.touched && this.control?.invalid;

        if (this.className) {
            classList[this.className] = true;
        }

        return classList;
    }

    dateRangePickerForm: FormGroup;
    /**
     * Determines whether touched callback on
     */
    onTouchedCallback: () => void;
    /**
     * Propagate change of input field component
     */
    onChangeCallback = (_: any) => {};
    /**
     * Creates an instance of input form field component.
     * @param controlContainer ControlContainer
     */
    constructor(
        public controlContainer: ControlContainer,
        private fb: FormBuilder
    ) {
        this.initializeForm();
    }
    /**
     * on init
     */
    ngOnInit(): void {
        this.control = this.form.get(this.formControlName);
        this.dateRangePickerForm.valueChanges.subscribe((value) => {
            this.onDateChange(value);
        });
    }
    /**
     * Gets error message
     */
    getErrorMessage() {
        if (this.control) {
            return ReactiveFormsService.errorMessage(this.control);
        }
        return null;
    }
    /**
     * Determines whether date change on
     * @param value any
     */
    onDateChange(value: any) {
        this.change.emit(value);
        this.writeValue(value);
    }
    /**
     * Writes value
     * @param value any
     */
    writeValue(value: any): void {
        if (!value) {
            this.dateRangePickerForm.reset();
        } else {
            this.dateRangePickerForm.patchValue({ value }, { emitEvent: false });
        }
        this.value = value;
        this.onChangeCallback(this.value);
    }
    /**
     * Registers on change
     * @param fn any
     */
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    /**
     * Registers on touched
     * @param fn any
     */
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    /**
     * Sets disabled state
     * @param isDisabled boolean
     */
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    private initializeForm() {
        this.dateRangePickerForm = this.fb.group({
            start: [null, null],
            end: [null, null],
        });
    }
}
